
import Nav from '@/components/nav/index'
export default {
  name: "header",
  components: {
    Nav
  },
  data() {
    return {
      openSearch: false, // 是否打开输入框
      searchValue: '',
      isOpenDropDown: false, //是否打开下拉，
      hoverImg: require('@/static/images/038.png'),
      leaveImg: require('@/static/images/select.png'),
      navShow: false,
      flag: false,
      hoverTitle: '', // 当前下划线位置
      navBarListLine: [], // 线条位置
      activePath: '/',
      lineObj:{
        left:0, //底部线的位置
        width:'32px' //底部线的宽度
      },
      selectObj:{
        left:0, //底部线的位置
        width:'32px' //底部线的宽度
      },
      oldActivePath: '',
    }
  },
  computed: { 
    navBarList() {
      let list = [
        {path: '/', title: 'nav.home', fullPath: '/',id:1},
        {path: '/AI', title: 'AI', fullPath: '/', id:11, linkTo: 'https://www.vastcloud.ai/'},
        {path: '/klyr', title: 'nav.KLYR', fullPath: '/klyr',id:10,  link: 'https://www.klyr.com.cn/'},
        {path: '/technology', title: 'nav.Coretechnology', fullPath: '/technology',id:2},
        {path: '/applicationIntroduction', title: 'nav.Applicationintroduction', fullPath: '/applicationIntroduction',id:3},
        {path: '/case', title: 'nav.Servicecase', fullPath: '/case',id:4},
        {path: '/esg', title: 'nav.ESG', fullPath: '/esg',id:5},
        {path: '/news', title: 'nav.Newscenter', fullPath: '/news',id:6},
        {path: '/aboutUs', title: 'nav.Aboutus', fullPath: '/aboutUs',id:7},
        // {path: '/#environmentalResponsibility', title: '社会责任', fullPath: '/#environmentalResponsibility'}, 
        // {path: '/joinUs', title: 'nav.Joinus', fullPath: '/joinUs',id:8},
        {path: '/#cooperativePartner', title: 'nav.Businesspartner', fullPath: '/#cooperativePartner',id:9}
      ];
      if (this.$i18n.locale == 'en') {
        return list;
      } else {  
        return list.filter(item => {
          return item.path != '/AI';
        });
      }
    }
  },
  watch: {
    '$route': {
      handler(res) {
        let path = res.path || '/'
        if(path === '/' || path === '/en') {
          path = path + `${res.hash || ''}`
        }
        if (path.indexOf('en#') > -1) {
          let active = path.replace('en#', '#');
          this.activePath = active;
          this.oldActivePath = active;
        } else if (path!='/' && path!='/en') {
          let active = '/' + path.split('/')[this.$i18n.locale == 'en' ? 2 : 1]
          this.activePath = active
          this.oldActivePath = active
        } else {    
          this.activePath = '/' 
          this.oldActivePath = '/'
        }

        this.getNavLine()
      },
    }
  },
  created() {
    let path = this.$route.path || '/'
    if(path === '/') {
      path = path + `${this.$route.hash || ''}`
    }
    this.activePath = path
    this.oldActivePath = path
   
  },
  async mounted() {
    await this.getNavLineData();
    this.getNavLine()

    this.isOpenDropDown = false
    document.addEventListener("click", this.bodyCloseMenus)
    // let selecNavInfo = sessionStorage.getItem('kp_select_nav_info')
    // if (selecNavInfo) {
    //   this.lineObj = JSON.parse(selecNavInfo)
    //   this.selectObj = JSON.parse(selecNavInfo)
    // }
    // this.computedLineInfo()
  },

  beforeDestroy() {
    document.removeEventListener("click", this.bodyCloseMenus);
  },
  methods: {
    getNavLineData() {
      this.$nextTick(()=>{
        this.navBarListLine = []
        this.navBarList.forEach((item, index) => {
          let obj = {
            left: 0,
            width: 0,
            fullPath: item.fullPath.split('/')[1],
            title: item.title,
          }
          obj.left = document.getElementById('nav-list' + item.id).offsetLeft + 'px'
          obj.width = document.getElementById('nav-list' + item.id).offsetWidth + 'px'
          this.navBarListLine.push(obj)
        })  
      })
    },
    getNavLine(currentFullRouter = this.$route.fullPath) {
      if (currentFullRouter.indexOf('/en/') > -1) {
        currentFullRouter = currentFullRouter.replace('/en/', '/')
      } else if (currentFullRouter.indexOf('/en#') > -1) {
        currentFullRouter = currentFullRouter.replace('/en#', '#')
      }
      let currentRouter = currentFullRouter.split("/");
      if (currentRouter.length >= 2) {
        currentRouter = currentRouter[1];
      } else {
        currentRouter = currentFullRouter;
      }
      const curLineObj = this.navBarListLine.find((o, i) => {
        return i > 0  && currentRouter == o.fullPath
      }) || this.navBarListLine[0]
      this.lineObj = curLineObj;
      this.selectObj = curLineObj;
      this.hoverTitle = curLineObj.title;
      // console.log('线条位置', curLineObj)
    },
    // 计算位置
    computedLineInfo(){
      let selecNavId = sessionStorage.getItem('kp_select_nav_id')
      if(selecNavId) {
        const domInfo = document.getElementById(selecNavId)
        let objInfo = {
          left:domInfo.offsetLeft+'px', //底部线的位置
          width:domInfo.offsetWidth+'px' //底部线的宽度
        }
        this.lineObj = objInfo
        this.selectObj = objInfo
      }
    },
    async changeLanguage() {
      this.$i18n.setLocale(this.$i18n.locale === 'en' ? 'zh' : 'en')
      await this.getNavLineData();
      this.$nextTick(() => {
        this.getNavLine()
        // this.computedLineInfo()
      })
      
    },
    // 选中导航元素
    selectNav(id, item){
      if (item?.linkTo) {
        window.location.href = item.linkTo
      }
      if (item?.link) {
        window.open(item.link, '_blank');
      }
      this.selectObj = JSON.parse(JSON.stringify(this.lineObj))
      sessionStorage.setItem('kp_select_nav_info',JSON.stringify(this.lineObj))
      sessionStorage.setItem('kp_select_nav_id',id)
    },
    mouseLeave() {
      this.getNavLine()
      // this.activePath = this.oldActivePath
      // this.lineObj = JSON.parse(JSON.stringify(this.selectObj))

    },
    mouseEnter(e, title) {
      this.activePath = 'reset'
      if (e) {
        this.lineObj={
          left:e.target.offsetLeft+'px',
          width:e.target.offsetWidth+'px'
        }
      }
      if(title) {
        this.hoverTitle = title
      }
      
    },
    leave() {
      this.navShow = false;
    },
    handleDropDown() {
      this.isOpenDropDown = !this.isOpenDropDown
      this.imgs = this.hoverImg
      this.flag = true
      if (!this.isOpenDropDown) return
      let len = this.list.length
      let index = Math.floor(Math.random() * len + 1) - 1
      this.dataArr = this.list[index]
    },
    routerLink(path) {
      this.isOpenDropDown = false
    },
    searchLink() {
      this.openSearch = !this.openSearch
      if(this.openSearch) {
        this.$nextTick(() => {
          this.$refs.searInputRef.focus()
        })
      }
    },
    closeSearchInput() {
      this.openSearch = false
    },
    bodyCloseMenus(e){
      if(this.openSearch) {
        this.openSearch = false
      }
      if(this.isOpenDropDown) {
        this.isOpenDropDown = false
      }
    },
    searchSubmit() {
      if(!this.searchValue) {
        return
      }
      for(let i = 0, len = this.searchResult.length; i < len; i++) {
        if(this.searchResult[i].title.includes(this.searchValue)) {
          this.$router.push({
            path: this.searchResult[i].path
          })
          if(this.openSearch) {
            this.openSearch = false
          }
          break;
        }
      }
    },
    linkHome() {
      this.$router.push({
        path: `/`
      })
    }
  }
}
